import { Platform } from 'react-native';

import { StreamTypes } from 'store/player/actions.types';
import {
    EpgProgram,
    RBChannel,
    RBProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import { VodEditorial } from 'services/data-manager/types';

import { convertStringToBoolean } from 'utils/convertStringToBoolean';

function isStartoverAvailable(
    channel: RBChannel | undefined,
    asset:
        | EpgProgram
        | RBProgram
        | VodEditorial
        | RecordingMetadata
        | undefined,
    streamType?: StreamTypes,
) {
    const startOverSupport = channel?.editorial.startOverSupport;
    const clientWebRestartControl = channel?.editorial.clientWebRestartControl;
    const clientMobileRestartControl =
        channel?.editorial.clientMobileRestartControl;
    const broadcastAsset = asset as EpgProgram | RBProgram | undefined;
    const channelClientRestartContorl = Platform.select({
        web: clientWebRestartControl,
        default: clientMobileRestartControl,
    });
    const assetClientRestartControl = Platform.select({
        web: asset?.clientWebRestartControl,
        default: asset?.clientMobileRestartControl,
    });

    if (
        !(startOverSupport && broadcastAsset?.isStartOver) &&
        streamType !== StreamTypes.vod
    ) {
        return false;
    }

    if (assetClientRestartControl != null) {
        return convertStringToBoolean(assetClientRestartControl);
    }

    if (channelClientRestartContorl != null) {
        return convertStringToBoolean(channelClientRestartContorl);
    }

    return false;
}

export default isStartoverAvailable;
